import { render, staticRenderFns } from "./FreightRowAction.vue?vue&type=template&id=84a42c32&"
import script from "./FreightRowAction.vue?vue&type=script&lang=ts&"
export * from "./FreightRowAction.vue?vue&type=script&lang=ts&"
import style0 from "./FreightRowAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports